export function isHisSelected(id, arr) {
  return arr.some(item => String(id) === String(item && item.id));
}

export function formatItemData(item, selectedList) {
  const { id, kfext, name, cname, ename, isParent, gender, disabled, tips } = item || {};

  const idVal = id || kfext;
  let nameVal = name;
  let genderVal = 0;
  let isFolder = false;
  let hasSelected = false;

  if (parseInt(isParent, 10) === 1) {
    isFolder = true;
  } else {
    if (ename && cname) {
      nameVal = `${cname}(${ename})`;
    } else {
      nameVal = cname || name;
    }
    genderVal = parseInt(gender, 10);
  }

  if (selectedList && isHisSelected(idVal, selectedList)) {
    hasSelected = true;
  }

  return {
    id: String(idVal),
    name: nameVal,
    gender: genderVal,
    isFolder,
    hasSelected,
    disabled,
    tips,
    originData: item,
  };
}

export function formatListData(arr, selectedList) {
  let formatArr = [];

  if (arr && arr.length) {
    formatArr = arr.map(item => formatItemData(item, selectedList));
  }

  return formatArr;
}
